import CryptoJS from "crypto-js";

function encrypt(plaintext: string, key: string): string {
  const cipher = CryptoJS.AES.encrypt(plaintext, key).toString();
  const encDataBase64 = CryptoJS.enc.Base64.stringify(
    CryptoJS.enc.Utf8.parse(cipher),
  );

  return encDataBase64;
}

function decrypt(encDataBase64: string, key: string): any {
  const decData = CryptoJS.enc.Base64.parse(encDataBase64).toString(
    CryptoJS.enc.Utf8,
  );

  const bytes = CryptoJS.AES.decrypt(decData, key).toString(CryptoJS.enc.Utf8);

  return JSON.parse(bytes);
}

/**
 // Usage:
const key = crypto.randomBytes(32); // Generate a 256-bit random key
const plaintext = "Hello, world!";
const encData = encrypt(plaintext, key);
const decryptedText = decrypt(encData, key);
console.log(decryptedText); // Outputs: 'Hello, world!'

 */

export const CryptoJsService = Object.freeze({
  encrypt,
  decrypt,
});
